import { Routes } from "@angular/router";
import { provideRouter } from "@angular/router";
import { authGuard } from "./core/guards/auth.guard";

export const routes: Routes = [
  {
    path: "login",
    loadComponent: () =>
      import("./features/login/login.component").then((m) => m.LoginComponent),
  },
  {
    path: "reset-password",
    loadComponent: () =>
      import("./features/reset-password/forgot-password.component").then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: "change-password",
    loadComponent: () =>
      import("./features/change-password/change-password.component").then(
        (m) => m.ChangePasswordComponent
      ),
  },
  {
    path: "user-registration",
    loadComponent: () =>
      import("./features/user-registration/user-registration.component").then(
        (m) => m.UserRegistrationComponent
      ),
  },
  {
    path: "home",
    loadComponent: () =>
      import("./features/home/home.component").then((m) => m.HomeComponent),
    canActivate: [authGuard],
    data: {
      roles: ["admin", "owner"],
    },
  },
  {
    path: "users",
    loadComponent: () =>
      import("./features/users/users.component").then((m) => m.UsersComponent),
    canActivate: [authGuard],
    data: {
      roles: ["admin", "owner"],
    },
  },
  {
    path: "chatbot",
    loadComponent: () =>
      import("./features/chatbot/chatbot.component").then(
        (m) => m.ChatbotComponent
      ),
    canActivate: [authGuard],
    data: {
      roles: ["admin", "owner", "user"],
    },
  },
  {
    path: "docs",
    loadComponent: () =>
      import("./features/docs/docs.component").then((m) => m.DocsComponent),
    canActivate: [authGuard],
    data: {
      roles: ["admin", "owner"],
    },
  },
  {
    path: "areas",
    loadComponent: () =>
      import("./features/areas/areas.component").then((m) => m.AreasComponent),
    canActivate: [authGuard],
    data: {
      roles: ["admin", "owner"],
    },
  },
  { path: "**", redirectTo: "/chatbot" },
];

export const routing = [provideRouter(routes)];
